import { ReactNode, useMemo, useState } from 'react';

import { IVehicle } from '../../schema/Vehicle.ts';
import { SelectedVehicleContext } from './SelectedVehicleContext';

type Props = {
  children: ReactNode;
};

export const SelectedVehicleProvider = ({ children }: Props) => {
  const [selectedVehicle, setSelectedVehicle] = useState<IVehicle | undefined>(undefined);

  const value = useMemo(() => ({ selectedVehicle, setSelectedVehicle }), [selectedVehicle]);

  return <SelectedVehicleContext.Provider value={value}>{children}</SelectedVehicleContext.Provider>;
};
